
import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid, Paper, Box, Chip, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
// F4.5 — drill-down do batch (mesmo componente do historico por automation).
import AutomationExecutionDetailDialog from "../../components/automation-execution-detail-dialog";
import Api from "../../services/api";
import * as calledsActions from '../../redux/actions/calleds';
import { Can } from '../../config/ability-context'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer';
import moment from "moment";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";

import SimpleDatePicker from '../../components/date-pickers/inline-no-today';
import Pagination from '@mui/material/Pagination';
import 'jspdf-autotable';
import LogoMarca from '../../images/new-logo-cmtech.png';
import Divider from '@mui/material/Divider';
import { PapiroConsole } from "../../utils/papiroConsole";
import ApiReports from "../../services/apireport";
import ScheduleReportButton from "../../components/report-schedule";
import fileDownload from 'js-file-download';

class AutomationExecutionReports extends Component {
  constructor(props) {
    super(props);
    this.Reload = this.Reload.bind(this);
    this.getFile = this.getFile.bind(this);
    this.getFileNew = this.getFileNew.bind(this);
    this.Reload();

    this.typingTimeout = null;

    const { userSession } = this.props;

    this.isClient = true;
    //this.isAdm = false;
    this.isAdmOrCoord = false;
    this.isTechinical = false;

    if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
      Api.logoff();
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4) {
        this.isAdmOrCoord = true;
      }

      if (item.role.roletype == 2) {
        this.isTechinical = true;
      }
    });

    this.state = {
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      allAutomationTypeList: [],
      automationsList: [],
      automationTypeFilter: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      showHeader: false,
      // F4.5 — drill-down modal
      detailOpen: false,
      selectedBatchId: null,
    };

    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.getAutomationsReportsToPdf = this.getAutomationsReportsToPdf.bind(this);
    this.clear = this.clear.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });

    await this.getAllAutomationsType();

    this.setState({ loading: false });
  }

  async changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState({ [stateName]: value });

    this.setState({ loading: false });
  };

  Reload = () => {
    const reload = localStorage.getItem('reload');
    if (reload == "true") {
      localStorage.setItem('reload', false);
    }

    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page });
    this.getAutomationsReports('', page);
  }

  exportPdf() {
    this.getAutomationsReportsToPdf();
  }

  setPagination(count, page) {
    let totalPage = Math.ceil(count / 10);
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10) {
          this.setState({ pageStart: 1, pageEnd: count });
        } else {
          this.setState({ pageStart: 1, pageEnd: 10 });
        }
      } else {
        let pageStart = ((page - 1) * 10) + 1;
        if (count >= page * 10) {
          this.setState({ pageStart: pageStart, pageEnd: page * 10 });
        } else {
          this.setState({ pageStart: pageStart, pageEnd: count });
        }
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 });
    }
  }

  async getAllAutomationsType() {
    let url = `/automation/type`;
    Api.get(url)
      .then((result) => {
        if (result.data.success) {

          const allAutomationTypeList = result.data;

          PapiroConsole.log({ allAutomationTypeList })

          this.setState({
            allAutomationTypeList: allAutomationTypeList.data,
          });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
                result.data.response &&
                result.data.response.data &&
                result.data.response.data.errors &&
                result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
              err.response.data &&
              err.response.data.errors &&
              err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  };

  async getFileNew() {
    this.setState({ loading: true });

    let dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    let dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const automationTypeFilter = this.state.automationTypeFilter.length > 0 ? this.state.automationTypeFilter.map(item => item.id).join(',') : '';

    let data = {
      dateStart,
      dateEnd,
      automationTypeFilter
    }

    let url = `/report/automation-execution/excel/new`;

    ApiReports.post(url, data)
      .then((response) => {

        PapiroConsole.log("response", response)

        if (response.data.success) {
          PapiroConsole.log("success")

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  async getFile() {
    const { intl } = this.props;

    this.setState({ loading: true });

    let dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    let dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');

    if (dateStart > dateEnd) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });
    } else {
      const automationTypeFilter = this.state.automationTypeFilter.length > 0 ? this.state.automationTypeFilter.map(item => item.id).join(',') : '';

      let url = `/report/automation-execution/excel?dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&automationTypeId=${automationTypeFilter}`;

      ApiReports.get(url, {
        responseType: 'blob'
      })
        .then((response) => {
          fileDownload(response.data, `relatorio_automacoes_executadas_${moment(this.state.dateStart).format('YYYY-MM-DD')}_${moment(this.state.dateEnd).format('YYYY-MM-DD')}.zip`);

          this.setState({ loading: false });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    }
  }

  async getAutomationsReports(filter = '', page = 1) {
    this.setState({ loading: true });

    let dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    let dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (dateStart > dateEnd) {
      const { intl } = this.props
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });
    } else {
      this.setState({ automationsList: [] });

      let url = `/report/automation-execution/paginate?page=${page}`;

      if (filter != '') {
        url = url + '&filter=' + filter;
      }

      const automationTypeFilter = this.state.automationTypeFilter.length > 0 ? this.state.automationTypeFilter.map(item => item.id).join(',') : '';

      url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&automationTypeId=${automationTypeFilter}`;

      this.setState({ showGrid: true, scheduleRequest: url });

      ApiReports.get(url)
        .then(result => {
          PapiroConsole.log(result)
          PapiroConsole.log("resultado entregue aqui")

          if (result.data.success) {
            let count = result.data.count;

            this.setState({ count: count });
            this.setPagination(count, page);

            const formattedList = result.data.data.map(item => {
              // F4.5 — API do 2DO responde JSON lowercase.
              // Preservamos os campos originais + normalizamos os campos F1/F2.4 novos
              // pra que o MyMaterialTable os enxergue por chave textual.
              const status = item.status ?? item.Status ?? (item.execution_success ? 'SUCCESS' : 'FAILED_UNEXPECTED');
              return {
                ...item,
                custom_execution_result: item.execution_success ? 'OK' : 'FALHA',
                custom_status: status,
                custom_duration: (item.duration_ms != null || item.durationms != null)
                  ? `${item.duration_ms ?? item.durationms}ms`
                  : '—',
                custom_agg: `${item.successful_actions ?? item.successfulactions ?? 0}/${item.failed_actions ?? item.failedactions ?? 0}/${item.skipped_actions ?? item.skippedactions ?? 0} (${item.total_actions ?? item.totalactions ?? 0})`,
                custom_trigger: item.trigger_type ?? item.triggertype ?? '—',
                custom_error: (item.error_code ?? item.errorcode) ? `${item.error_code ?? item.errorcode}` : '',
                custom_batch_id: item.batch_id ?? item.batchid ?? null,
                executed_at: item.executed_at ? moment(item.executed_at).format('DD/MM/YYYY HH:mm:ss') : ''
              }
            });

            this.setState({
              automationsList: formattedList,
              loading: false,
            });
          }
          else {
            this.setState({
              loading: false, openNotification: true, notificationVariant: 'error',
              notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
          }
        })
        .catch(err => {
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(err);
        });

    }
  };

  clear() {
    document.location.reload();
  }

  getAutomationsReportsToPdf() {
    this.setState({
      openNotification: true,
      notificationVariant: 'info',
      notificationMessage: this.props.intl.formatMessage({ id: "routine.in.maintenance" })
    })
  };

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    await this.getAutomationsReports(this.props.location.state);

  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;

    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      return (
        <>
          <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
            <Accordion >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid container style={{ marginBottom: 20 }} spacing={2} >
                  <Grid item xs={12} sm={6} md={3}>
                    <SimpleAutoCompleteMultiple label={intl.formatMessage({ id: "automation.type" })} options={this.state.allAutomationTypeList} stateName='automationTypeFilter' changeSelect={this.changeValues} selected={this.state.automationTypeFilter} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}  >
                    <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container style={{ marginBottom: 10 }}>
              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary'

                >
                  {<FormattedMessage id="filter" />}
                </Button>
              </Grid>

              {this.state.showGrid && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={this.getFileNew}

                >
                  {<FormattedMessage id="export.plan" />}
                </Button>
              </Grid>}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="automation-execution" request={this.state.scheduleRequest} color="secondary" />
</Grid>}

              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='button'
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={this.clear}

                >
                  {<FormattedMessage id="clear" />}
                </Button>
              </Grid>

            </Grid>
          </form>
          {this.state.showGrid &&
            <>
              <MyMaterialTable
                title=""
                columns={[
                  { title: intl.formatMessage({ id: "id" }), field: 'id' },
                  { title: intl.formatMessage({ id: "automation.name" }), field: 'automationname' },
                  { title: intl.formatMessage({ id: "enter.the.called.number" }), field: 'called_id' },
                  { title: intl.formatMessage({ id: "automation.last.execution" }), field: 'executed_at' },
                  {
                    title: intl.formatMessage({ id: "automation.history.col.status" }),
                    field: 'custom_status',
                    render: (row) => {
                      const s = row.custom_status || '';
                      const map = {
                        SUCCESS: { bg: '#e8f5e9', color: '#2e7d32' },
                        PARTIAL: { bg: '#fff3e0', color: '#e65100' },
                        FAILED_HANDLER: { bg: '#ffebee', color: '#c62828' },
                        FAILED_TIMEOUT: { bg: '#ffebee', color: '#c62828' },
                        FAILED_UNEXPECTED: { bg: '#ffebee', color: '#c62828' },
                        SKIPPED_DEDUP: { bg: '#f5f5f5', color: '#616161' },
                        SKIPPED_CONDITION: { bg: '#f5f5f5', color: '#616161' },
                      };
                      const st = map[s] || { bg: '#eee', color: '#333' };
                      return <Chip size="small" label={s || '—'} sx={{ backgroundColor: st.bg, color: st.color, fontWeight: 600 }} />;
                    }
                  },
                  { title: intl.formatMessage({ id: "automation.history.col.duration" }), field: 'custom_duration' },
                  { title: intl.formatMessage({ id: "automation.history.col.actions.summary" }), field: 'custom_agg' },
                  { title: intl.formatMessage({ id: "automation.history.col.trigger" }), field: 'custom_trigger' },
                  {
                    title: intl.formatMessage({ id: "automation.history.col.error" }),
                    field: 'custom_error',
                    render: (row) => row.custom_error
                      ? <span style={{ color: '#c62828', fontFamily: 'monospace', fontSize: 12 }}>{row.custom_error}</span>
                      : '—'
                  },
                  {
                    title: intl.formatMessage({ id: "automation.history.col.view" }),
                    field: 'custom_batch_id',
                    render: (row) => (
                      <Tooltip title={intl.formatMessage({ id: "automation.history.view.actions" })}>
                        <span>
                          <IconButton
                            size="small"
                            disabled={!row.custom_batch_id}
                            onClick={() => this.setState({ detailOpen: true, selectedBatchId: row.custom_batch_id })}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )
                  },
                ]}
                data={this.state.automationsList}
              />

              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </>
          }
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            {this.state.showHeader &&
              <Grid container>
                <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{ padding: '2px', minWidth: 600 }}>
                  <Card  >

                    <CardContent>

                      <img src={LogoMarca} style={{ width: "70px" }} /> <span style={{ fontSize: 18 }}> {<FormattedMessage id="automations.execution" />}</span>
                      <Divider />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>}
            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>

                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {<FormattedMessage id="automations.execution" />}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
            <Can I="List" a="Called">
              {tableList()}
            </Can>


            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />

            {/* F4.5 — Drill-down do batch (mesmo componente da tela de historico por automation) */}
            <AutomationExecutionDetailDialog
              open={this.state.detailOpen}
              batchId={this.state.selectedBatchId}
              onClose={() => this.setState({ detailOpen: false, selectedBatchId: null })}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

AutomationExecutionReports.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AutomationExecutionReports)));
AutomationExecutionReports.contextType = AbilityContext;